module.exports = __webpack_public_path__ + "static/img/title.6fdd127.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/elag_geruste/title.jpeg
// module id = 368
// module chunks = 1